// -----------------------------------------------------------------------------
// Scripts
// -----------------------------------------------------------------------------

$.fn.preload = function() {
    this.each(function() {
        $('<img/>')[0].src = 'resources/themes/makeitstick/images/' + this;
    });
}

var SCRIPTS = SCRIPTS || {};
var isMobileOrTablet;
var dynamicrequest = null;
var isOldBrowser;
var headerheight = 0;
var header;
var menu;
var button;
var width;
var menutimeout = null;
var lazyInstance;
var linedot = null;
var line = null;

(function($) {
    isMobileOrTablet = ($('body').data('mobileortablet') == '1' ? true : false);
    isOldBrowser = ($('html').hasClass('ieold') ? true : false);
    //$(['loading.gif']).preload();

    SCRIPTS = {
        settings: {},
        init: function() {
            _this = this;
            header = $('#js-header');
            menu = $('#js-menu');
            button = $('.js-menu-btn');
            line = $('#js-line');
            if ($('.js-linedot').length > 0) {
                linedot = $('.js-linedot');
            }

            this.nav.init();

            if ($('#js-tabs').length > 0) {
                this.tabs.init();
            }

            this.articleTop.init(0);

            $(window).bind('load', function() {
                _this.articleTop.init(0);
            });

            $(window).bind('resize', function() {
                //_this.setscroll(_this);
                width = ($(window).width());
                headerheight = header.height();

                if (menu.hasClass('mainmenu--open')) {
                    if (width > 768) {
                        button.click();
                    }
                    //menu.css('top', headerheight);
                } else {
                    //menu.css('top', 'auto');
                }

                _this.articleTop.init(1);
                if (linedot) {
                    _this.lineDot.init();
                }
            });

            $(window).bind('scroll', function() {
                width = ($(window).width());

                if (width > 768) {
                    //header.css('margin-top', $(window).scrollTop());
                } else {
                    //header.css('margin-top', 0);
                }
            });

            if ($('.js-grid').length > 0) {
                this.gridblocks.init('grid');
            }

            if ($('.js-votes').length > 0) {
                this.votes.init('vote');
            }

            $.fancybox.defaults.smallBtn = false;
            $.fancybox.defaults.infobar = false;
            $.fancybox.defaults.padding = 0;
            $.fancybox.defaults.gutter = 0;
            $.fancybox.defaults.toolbar = true;
            $.fancybox.defaults.buttons = ['close'];
            $.fancybox.defaults.mobile = {
                baseClass: 'fancybox-mobile',
                transitionEffect: false,
                animationEffect: "fade"
            };

            $.fancybox.defaults.btnTpl = {
                arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left icon-arrow-left" title="{{PREV}}"></button>',
                arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right icon-arrow-right" title="{{NEXT}}"></button>',
                close: '<button data-fancybox-close class="fancybox-button fancybox-button--close icon-close" title="{{CLOSE}}"></button>'
            };

            $.fancybox.defaults.spinnerTpl = '<div class="fancybox-loading icon-bulb"></div>';
            // Open/close animation type
            // Possible values:
            //   false            - disable
            //   "zoom"           - zoom images from/to thumbnail
            //   "fade"
            //   "zoom-in-out"
            //
            $.fancybox.defaults.animationEffect = "fade";

            //   "fade'
            //   "slide'
            //   "circular'
            //   "tube'
            //   "zoom-in-out'
            //   "rotate'
            $.fancybox.defaults.transitionEffect = "fade";
            $.fancybox.defaults.transitionDuration = 500;
            $.fancybox.defaults.touch = {
                vertical: false, // Allow to drag content vertically
                momentum: false // Continue movement after releasing mouse/touch when panning
            };
            $.fancybox.defaults.helpers = {
                overlay: {
                    closeClick: true, // if true, fancyBox will be closed when user clicks on the overlay
                    speedOut: 200, // duration of fadeOut animation
                    showEarly: true, // indicates if should be opened immediately or wait until the content is ready
                    css: {}, // custom CSS properties
                    locked: true // if true, the content will be locked into overlay
                }
            };
            $.fancybox.defaults.ajax = {
                settings: {
                    data: {
                        fancybox: false
                    }
                }
            };
            /*
            $.fancybox.defaults.afterShow = function(instance, current) {
                var share = $('<a>').attr('href', 'javascript:;').text('Share').addClass('share icon-share-after');
                share.socialShare({
                    social: 'facebook,google,linkedin,twitter',
                    shareUrl: _this.basehref + current.src
                });
                $('.fancybox-caption').append(share)
            };
            */

            if ($('.js-fancybox').length > 0) {
                $(".js-fancybox").each(function() {
                    $(this).attr('href', $(this).data('href'));
                }).fancybox({
                    type: 'iframe'
                });
            }

            if ($('.js-link').length > 0) {
                $(".js-link").click(function() {
                    window.location.href = $(this).data('href');
                });
            }
        },
        articleTop: {
            init: function(resize) {
                if (resize == 0) {
                    width = ($(window).width());
                    headerheight = header.height();
                }

                //if (width <= 768) {
                $('article#main').css('padding-top', headerheight);
                //} else {
                //    $('article#main').css('padding-top', 0);
                //}
            }
        },
        votes: {
            init: function() {
                $vote = 0;
                $voteoptions = $('.js-votes').find('li');
                $voteoptions.bind('click mouseenter mouseleave', function(event) {
                    $voteoptions.removeClass('fill' + (event.type == 'click' ? '' : 'hover'));
                    $vote = $(this).data('vote');

                    console.log($vote);

                    if (event.type != 'mouseleave') {

                        $voteoptions.each(function() {
                            if ($(this).data('vote') <= $vote) {
                                $(this).addClass('fill' + (event.type == 'click' ? '' : 'hover'));
                            }
                        });
                    }

                    if (event.type == 'click') {
                        $('#VoteForm_VoteForm_Rating').val($vote);
                    }
                });
            }
        },
        gridblocks: {
            grid: null,
            filterbutton: null,
            init: function(selector) {
                var _this = this;
                var ajaxurl;

                _this.grid = $('.js-' + selector);

                _this.grid.imagesLoaded(function() {
                    _this.grid.packery({
                        itemSelector: '.js-' + selector + ' .' + selector + '__item',
                        gutter: '.grid__gutter',
                        percentPosition: true

                    });
                });


                $('#loadmore a').click(function(e) {
                    _this.loadmoreaction(selector, $(this));
                });
            }
        },
        nav: {
            lastId: 0,
            topMenuHeight: 1,
            scrollItems: null,
            init: function() {
                var _this = this;

                button.on('click', function(e) {
                    e.preventDefault();

                    if (button.hasClass('is-active')) {
                        button.removeClass('is-active');
                    } else {
                        button.addClass('is-active');
                    }

                    menu.toggleClass('mainmenu--open');
                    header.toggleClass('header--menuopen');

                    headerheight = header.height();
                    /*
                    menu.css({
                        'top': headerheight,
                        'height': ($('body').height() - headerheight)
                    });
                    */
                });

                menu.find('.main--haschildren').on('mouseenter', function() {
                    if (width > 768) {
                        $(this)
                            .addClass('main--active')
                            .find('ul.children')
                            .css('display', 'flex').hide()
                            .slideDown(250);
                    }
                });

                menu.find('.main--haschildren').on('mouseleave', function() {
                    if (width > 768) {
                        $(this)
                            .removeClass('main--active')
                            .find('ul.children')
                            .addClass('children--hidden').hide();
                    }
                });
            }
        },
        tabs: {
            tablinks: $('#js-tabs li a'),
            init: function() {
                var _this = this;

                _this.tablinks.each(function() {
                    $(this).click(function() {
                        console.log($(this).data('tab'));

                        $('.tab-content').removeClass('tab-content--active');
                        $('.tab-content#tab-' + $(this).data('tab')).addClass('tab-content--active');

                        _this.tablinks.removeClass('active');
                        $(this).addClass('active');
                    });

                });
            }
        },
        scrollToDiv: {
            init: function(element, offsetadjust) {
                var headerheight = header.height();
                var scrolltop = ($(document).scrollTop());

                if (offsetadjust == 0) {
                    offsetadjust = headerheight;
                }

                if (element == 0) {
                    var totalScroll = offset;
                } else {
                    var offset = element.offset();
                    var totalScroll = (offset.top - offsetadjust);
                }

                var animtime = ((scrolltop - totalScroll) * .5);
                animtime = (animtime < 500 ? 500 : animtime);

                //console.log(animtime);

                $('body,html').animate({
                    scrollTop: totalScroll,
                    easing: 'easeOutCubic'
                }, animtime);
            }
        },
        lineDot: {
            init: function() {

                var linedottop = linedot.offset().top;
                var linedotheight = linedot.height();
                var linescrollto = (linedottop + linedotheight);

                line.css('height', linescrollto + 'px');

            }
        }
    }

    SCRIPTS.init();

    $(window).bind('load', function() {
        /*
        lazyInstance = $('.lazy').lazy({
            attribute: "data-srcset",
            chainable: false
        });
        */

        if (linedot) {
            SCRIPTS.lineDot.init();
        }

        var body = $('body');
        $.ajaxSetup({
            cache: true
        });
    });

})(jQuery);
